const TRACKING_PARAMS = new Set([
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    '_ga', '_gid', '_gac', '_gl',
    'fbclid', 'gclid', 'dclid', 'msclkid', 'yclid',
    'mc_cid', 'mc_eid',
]);
export function canonicalizeUrl(input) {
    const u = new URL(input);
    u.hostname = u.hostname.toLowerCase();
    for (const param of TRACKING_PARAMS)
        u.searchParams.delete(param);
    u.hash = '';
    // Strip trailing slash on path (but keep root '/')
    if (u.pathname.length > 1 && u.pathname.endsWith('/')) {
        u.pathname = u.pathname.slice(0, -1);
    }
    // Strip trailing '?' if all params were tracking
    const search = u.searchParams.toString();
    const query = search ? `?${search}` : '';
    const path = u.pathname === '/' ? '' : u.pathname;
    return `${u.protocol}//${u.host}${path}${query}`;
}
export function urlsMatch(a, b) {
    try {
        const ca = new URL(canonicalizeUrl(a));
        const cb = new URL(canonicalizeUrl(b));
        return ca.host === cb.host && ca.pathname === cb.pathname;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=urlMatching.js.map